import { render } from "./DatenschutzSection.vue?vue&type=template&id=eb5ca862&scoped=true"
import script from "./DatenschutzSection.vue?vue&type=script&lang=js"
export * from "./DatenschutzSection.vue?vue&type=script&lang=js"

import "./DatenschutzSection.vue?vue&type=style&index=0&id=eb5ca862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb5ca862"]])

export default __exports__